document.addEventListener('DOMContentLoaded', function() {
  var productsOnPage = document.querySelector('.products-onpage');
  var nextUrl = productsOnPage.getAttribute('data-next-url');
  var loadMoreBtn = document.querySelector('.load-more_btn');
  var loadMoreSpinner = document.querySelector('.load-more_spinner');
  var viewedText = document.querySelector('.viewed-text'); // The element for displaying the viewed text
  var totalProducts = parseInt(productsOnPage.getAttribute('data-total-products')); // Assuming total products are set in the data attribute
  var viewedProducts = productsOnPage.children.length;
  console.log('viewedProducts = '+viewedProducts);

  updateViewedText();

  loadMoreBtn.addEventListener('click', function() {
    loadMoreProducts();
  });

  function loadMoreProducts() {
    if (!nextUrl) {
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', nextUrl, true);

    xhr.onloadstart = function() {
      loadMoreBtn.style.display = 'none';
      loadMoreSpinner.style.display = 'block';
    };

    xhr.onload = function() {
      loadMoreSpinner.style.display = 'none';

      if (xhr.status >= 200 && xhr.status < 400) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(xhr.responseText, 'text/html');
        var newProducts = doc.querySelector('.products-onpage');
        var newUrl = newProducts.getAttribute('data-next-url');
        var newProductsHtml = newProducts.innerHTML;

        productsOnPage.insertAdjacentHTML('beforeend', newProductsHtml);
        viewedProducts += newProducts.children.length;
        updateViewedText();

        if (newUrl) {
          loadMoreBtn.style.display = 'flex';
          nextUrl = newUrl;
        } else {
          loadMoreBtn.style.display = 'none';
        }
      } else {
        // Handle error response
        loadMoreBtn.style.display = 'flex';
        console.log('Failed to load more products. Please try again.');
      }
    };

    xhr.onerror = function() {
      // Handle network error
      loadMoreSpinner.style.display = 'none';
      loadMoreBtn.style.display = 'flex';
      console.log('Failed to load more products. Please try again.');
    };

    xhr.send();
  }

  function updateViewedText() {
    viewedText.textContent = 'Viewed ' + viewedProducts + ' of ' + totalProducts + ' items';
  }
});